import React from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import _ from 'lodash';
import withUpload from "../../../../hoc/withUpload";
import {Button} from "../../../../components/Button";
import "./CoverFromUpload.scss";
import {updateCoverVideoFile} from "../../../../../creators/media";

class coverFromUpload extends React.Component {
    constructor(props){
        super(props);
        this.id = _.random(0, 99999);
        this.state = {
            errorMessage: '',
            preview: this.props.preview,
            uploadedMedia: {},
            isUploaded: false,
        };

        this.inputRef = React.createRef();

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.preview !== this.props.preview){
            this.setState({preview: this.props.preview});
            this.props.uploadFile();
        }
    }
    componentDidMount() {
        if(this.inputRef){
            this.inputRef.current.click()
        }
    }

    onUploadError({response}){
        this.props.reset();
        let message = '';
        switch (response.statusCode) {
            case 413:
                message = `Fichier trop lourd, maximum accepté : ${response.errors.maxFileSizeStr}`;
                break;
            case 415:
                message = `Fichier non accepté, sont acceptés : ${response.errors.allowedTypes.join(', ')}`;
                break;
            case null:
                message = ``;
                break;
            default :
                message = 'Envoi du fichier impossible, erreur système inconnue';
                break;
        }
        this.setState({errorMessage: message, preview: ""})
    }

    onUploadSuccess(data){
        if(data){
            this.setState({uploadedMedia: data, isUploaded: true, preview : data.preview});
        }

    }

    handleSubmit(){
        this.props.reset();
        this.props.handleClose();
        // console.log(this.state.uploadedMedia);

        this.props.updateCoverVideoFile(this.props.mediaId, {fileId : this.state.uploadedMedia._id});
        // call api
    }

    render(){
        return <div id={"cover-from-upload"}>
            <div id={"uploads"} className={"modal-container"}>
                {/*<div className={"modal-topline"}>
                    {`Télécharger une cover`}
                </div>*/}
                <div className={"modal-body"}>
                    {this.state.preview &&
                        <div className={"img-preview-container"}>
                            <img alt={""} className={`img-preview`} src={this.state.preview} />
                        </div>
                    }
                    <input type="file"
                           ref={this.inputRef}
                           id={this.id}
                           key={this.props.loadedFile.name}
                           style={{display:'none'}}
                           accept="image/jpeg, image/png"
                           disabled={this.props.uploading}
                           onChange={this.props.loadFile.bind(this)}/>

                    <label htmlFor={this.id} className={"upload-input-btn"}>
                        <div className="btn white"
                             style={{background: `linear-gradient(to right,#51a9fd ${this.props.uploadProgress.percentCompleted}%,#1F7DEC ${this.props.uploadProgress.percentCompleted}%)`}}
                        >
                            {this.props.uploading ? (
                                `Envoi... ${Math.round(this.props.uploadProgress.eta / 1000)}s (${this.props.uploadProgress.kos}ko/s)`
                            ) : (
                                _.truncate(this.props.loadedFile.name, {length:this.props.nameLength || 25}) || 'Choisissez un fichier'
                            )}
                        </div>
                    </label>

                </div>
                <div className={"modal-baseline2"}>
                    {this.state.errorMessage && <span className={"warning upload-error-message"}>{this.state.errorMessage}</span>}
                    {!this.props.uploading &&
                        <Button btnStyle={"grey"}
                                size={"small"}
                                onClick={()=>this.props.handleClose()}
                                content={"Annuler"}/>
                    }
                    {this.props.loadedFile.name && (
                        this.props.uploading &&
                        <Button btnStyle={"grey"}
                                size={"small"}
                                onClick={()=>this.props.reset()}
                                content={"Annuler"}/>
                    )}
                    {this.state.isUploaded && (
                        <Button btnStyle={"primary-reverse"}
                                size={"small"}
                                className={"ml-8"}
                                onClick={()=>this.handleSubmit()}
                                content={"Utiliser cette image en couverture"}/>
                    )}
                </div>
            </div>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    updateCoverVideoFile
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withUpload(coverFromUpload));